import { FC } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Chat } from '../../types';
import { ChatAvatar } from '../ChatAvatar/ChatAvatar';
import { getChatUser, getChatUserName } from '../../lib/helpers';

interface ChatHeaderProps {
  chat: Chat;
  currentUserId: number;
  onBack?: () => void;
}

export const ChatHeader: FC<ChatHeaderProps> = ({ chat, currentUserId, onBack }) => {
  const chatUser = getChatUser(currentUserId, chat.users);
  const chatUserName = getChatUserName(currentUserId, chat.users);

  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-(--neutral-black-NB100) bg-white">
      <div className="flex items-center gap-3">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="md:hidden p-1 rounded-lg! text-(--neutral-black-NB600) hover:bg-(--neutral-white-NW800) transition-colors cursor-pointer"
            title="Back to conversations"
          >
            <ArrowLeft size={20} />
          </button>
        )}
        {chatUser && <ChatAvatar user={chatUser} size="md" isOnline />}
        <div className="flex flex-col">
          <span className="[font-size:var(--fs-p3)]! font-semibold text-(--neutral-black-NB1000)">
            {chatUserName}
          </span>
          {/* TODO: Add online status when backend ready */}
          {/* <span className="[font-size:var(--fs-l6)]! text-[#47B881]">Online</span> */}
        </div>
      </div>
      {/* TODO: Add call and more options buttons when backend ready*/}
      {/* <div className="flex items-center gap-1">
        <IconButton icon={<Phone size={20} />} label="Voice call" />
        <IconButton icon={<Video size={20} />} label="Video call" />
        <IconButton icon={<MoreVertical size={20} />} label="More options" />
      </div> */}
    </div>
  );
};
